import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroModeloEmail from './Components/CadastroModeloEmail';

//Api
import modelosEmail_api from '../../../../api/modelosEmail_api';
import { showMessage } from '../../../../helpers/message';
import { useAuth } from '../../../../context/auth';
import { actionsTable } from '../../../../constants/MaterialTable';

export default function ModelosDeEmail({ permissoes }) {
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Pegando o estado de controle do loading na tela
    const { setLoading } = useAuth();

    //Estado de controle de exibição da tela de cadastro de um novo modelo de email
    const [cadastro, setCadastro] = useState(false);

    //Estado de controle da lista de modelos de email
    const [modelosEmail, setModelosEmail] = useState([]);

    //Estado de controle de visualização de um modelo de email especifico
    const [idModelo, setIdModelo] = useState(null);

    //Função do botão visualizar da lista
    const editar = (modelo) => {
        setIdModelo(modelo.id)
    };

    //Ações que a tabela terá
    const actions = [
        editavel ?
            actionsTable.editar(editar)
            :
            actionsTable.visualizar(editar)
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ]

    //Função que carrega a lista de documentos
    const loadModelosEmail = () => {
        setLoading(true);
        modelosEmail_api.getList().then(response => {
            setModelosEmail(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    useEffect(() => {
        loadModelosEmail();
    }, []);
    if (cadastro || idModelo)
        return <CadastroModeloEmail btnVoltar={() => {
            setCadastro(false);
            setIdModelo(null);
            loadModelosEmail();
        }} id={idModelo} editavel={editavel} />

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Modelos de e-mails</h4>
                {editavel &&
                    <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
                }
            </div >
            <TabelaListagem actions={actions} title={"Lista de modelos de e-mail"} options={{ print: false, search: true, pagination: true }} headers={headers} items={modelosEmail} />
        </>
    )
}